import { render } from "./ShowStocks.vue?vue&type=template&id=bef0cce0"
import script from "./ShowStocks.vue?vue&type=script&lang=js"
export * from "./ShowStocks.vue?vue&type=script&lang=js"
script.render = render

export default script